<template>
  <div class="custom-event-select-speaker" :class="activeList ? 'isfocused' : ''">
    <div class="selected-area" @click="activeList = !activeList">
      <div class="speaker-img">
        <img :src="selected.image" v-if="selected.image != null" />
        <i class="fas fa-user" v-else></i>
      </div>
      <div class="speaker-info" v-if="selected.fullName != null">
        <div class="title">
          {{ selected.fullName }}
        </div>
        <div class="firm">
          <span v-if="selected.title != null && selected.title != ''">{{ selected.title }}</span>
          <span v-if="selected.firmName != null && selected.firmName != ''">
            @
            <b>{{ selected.firmName }}</b>
          </span>
        </div>
        <div class="presentation">{{ selected.presentation }}</div>
      </div>
      <div class="speaker-info" v-else>
        {{ $t("contentManagement.eventProgram.components.selectSpeaker") }}
      </div>
      <i class="el-icon-arrow-down" :class="{ active: activeList }"></i>
    </div>
    <transition name="el-zoom-in-top">
      <div class="list-container" v-show="activeList">
        <div class="list-area ">
          <div class="search-area">
            <el-input v-model.lazy="speakerQuery" @input="speakerSearch" :prefix-icon="loading ? 'el-icon-loading' : 'fas fa-search'" clearable @clear="speakerQuery = null" :placeholder="$t('contentManagement.eventProgram.components.searchSpeaker')"></el-input>
          </div>
          <template v-if="speakerList.length > 0">
            <div
              class="list-item"
              v-for="(item, index) in speakerList"
              :key="index"
              @click="
                selected = item;
                activeList = false;
              "
            >
              <div class="speaker-img">
                <img :src="item.image" v-if="item.image != null" />
                <i class="fas fa-user" v-else></i>
              </div>
              <div class="speaker-info" v-if="item.fullName != null">
                <div class="title">
                  {{ item.fullName }}
                </div>
                <div class="firm">
                  <span v-if="item.title != null && item.title != ''">{{ item.title }}</span>
                  <span v-if="item.firmName != null && item.firmName != ''">
                    @
                    <b>{{ item.firmName }}</b>
                  </span>
                </div>
                <div class="presentation">{{ item.presentation }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { title } from "process";
export default {
  props: ["value", "selectedID", "selectedPresentationId"],
  data() {
    return {
      axios,
      loading: false,
      selectTiemout: null,
      speakerList: [],
      activeList: false,
      speakerQuery: null,
      selected: {
        image: null,
        fullName: null
      }
    };
  },
  methods: {
    async speakerSearch() {
      this.loading = true;
      if (this.selectTiemout != null) clearTimeout(this.selectTiemout);
      this.selectTiemout = setTimeout(async () => {
        (this.loading = false), (this.speakerList = []);
        var res = await axios.post("Speaker/List", { skip: 0, take: 20, searchTerm: this.speakerQuery });
        res.data.data.items.map(x => {
          var payload = {
            fullName: x.fullName,
            presentation: null,
            id: x.id,
            presentationId: null,
            image: x.image,
            firmName: x.firmName,
            title: x.title
          };
          this.speakerList.push(payload);
          x.presentations.map(y => {
            var payload = {
              fullName: x.fullName,
              presentation: y.title,
              id: x.id,
              presentationId: y.id,
              image: x.image,
              firmName: x.firmName,
              title: x.title
            };
            this.speakerList.push(payload);
          });
        });
        //this.speakerQuery = null
      }, 500);
    }
  },
  async created() {
    if (this.selectedID != null) {
      var res = await axios.post("Speaker/Get", { id: this.selectedID });
      var speaker = res.data.data.item;

      var payload = {
        fullName: speaker.fullName,
        presentation: null,
        id: speaker.id,
        presentationId: null,
        image: speaker.image,
        firmName: speaker.firmName
      };
      if (this.selectedPresentationId != null) {
        var presentation = speaker.presentations.find(x => x.id == this.selectedPresentationId);
        payload.presentation = presentation.title;
        payload.presentationId = presentation.id;
      }
      this.selected = payload;
    }
  },
  watch: {
    activeList(newVal) {
      if (newVal) {
        this.speakerSearch();
      }
    },
    selected: function() {
      if (this.selected != null) {
        this.$emit("presentationId", this.selected.presentationId);
        this.$emit("speakerId", this.selected.id);
        this.speakerQuery = null;
        this.speakerList = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.custom-event-select-speaker {
  padding: 10px;
  border: 0.5px solid #d6d9d9;
  border-radius: 8px;
  background-color: white;
  position: relative;
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

  &:hover {
    border-color: #c0c4cc;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }

  &.isfocused {
    border-color: #03658c;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .selected-area {
    i.el-icon-arrow-down {
      flex-shrink: 0;
      color: #c0c4cc;
      transition: all 0.5s;
      font-size: 14px;
      &.active {
        transition: all 0.5s;
        transform: rotate(-180deg);
      }
    }
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    .presentation {
      color: #03658c;
      font-weight: 500;
    }
    .speaker-info {
      display: flex;
      flex-direction: column;
      margin-right: auto;
      .title {
        font-weight: bold;
      }
      .firm {
        font-weight: 400;
        color: #606266;
      }
    }
    .speaker-img {
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        font-size: 16px;
        margin: 0px;
        padding: 0px;
        color: #03658c;
        margin-right: -2px;
      }
      flex-shrink: 0;
      width: 40px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      height: 40px;
      border-radius: 50%;
      border: 0.5px solid #d6d9d9;
    }
  }
  .list-container {
    margin-top:6px;
    width: 100%;
    position: absolute;
    top: 100%;
    left: 0;
    max-height: 250px;
    z-index: 3000 !important;
    box-shadow: 0px 2px 12px -4px rgba(0, 0, 0, 0.36);
    overflow-y: auto;
  }
  .list-area {
    background: white;
    
    border-radius: 8px;
    .search-area {
      padding: 10px;
    }
    .list-item {
      cursor: pointer;
      padding: 10px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      gap: 0.5rem;
      align-items: center;
      border-bottom: 1px solid #f1f1f1;

      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background-color: #f1f1f1;
      }
      .presentation {
        color: #03658c;
        font-weight: 500;
      }
      .speaker-info {
        display: flex;
        flex-direction: column;
        .title {
          font-weight: bold;
          span {
            font-weight: 400;
            color: #ccc;
          }
        }
      }
      .speaker-img {
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 16px;
          margin: 0px;
          padding: 0px;
          color: #03658c;
          margin-right: -2px;
        }
        flex-shrink: 0;

        width: 40px;
        height: 40px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        border-radius: 50%;
        border: 0.5px solid #d6d9d9;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eventprogram/CustomSelectSpeaker.vue